import React from 'react';
import { useIsSC } from '../../../hooks/useIsSC';
import Skeleton from '../../Skeleton/Skeleton';

export const defaultConfig = {
  width: '100%',
  height: '100%',
  containerTestId: 'gameGridItemSkeleton',
};

export const GameGridItemSkeleton = ({ config = {} }) => {
  const isSCCOM = useIsSC();

  return (
    <Skeleton
      config={{
        ...defaultConfig,
        ...config,
        borderRadius: isSCCOM ? '20px' : 'var(--radius-md)',
      }}
    />
  );
};
